import { proxy, snapshot, useSnapshot } from "@web-monorepo/hooks";
import { GroupsState, initialGroupsState } from ".";

const store = proxy<GroupsState>({ ...initialGroupsState });

export const toolkitGroupsActions = {
  mergeGroups(payload: Partial<GroupsState>) {
    Object.assign(store, payload);
  },
};

export function useToolkitGroupsStore() {
  return useSnapshot(store);
}

export function getToolkitGroupsState() {
  return snapshot(store);
}

export function resetToolkitGroupsStore() {
  Object.assign(store, initialGroupsState);
}
